import { Routes, Route } from 'react-router-dom';
import { AuthGuard, GuestGuard } from '../guards/AuthGuard';
import { publicRoutes, privateRoutes, useCommonRoutes } from './config';
import Layout from '../components/Layouts';

export function AppRoutes() {
  const commonRoutes = useCommonRoutes();

  return (
    <Routes>
      {/* Common routes (no auth required) */}
      {commonRoutes.map(route => (
        <Route key={route.path} path={route.path} element={route.element} />
      ))}

      {/* Public routes (guest only) */}
      {publicRoutes.map(route => (
        <Route
          key={route.path}
          path={route.path}
          element={<GuestGuard>{route.element}</GuestGuard>}
        />
      ))}

      {/* Private routes (authenticated only) with layout */}
      <Route element={<Layout />}>
        {privateRoutes.map(route => (
          <Route
            key={route.path}
            path={route.path}
            element={<AuthGuard>{route.element}</AuthGuard>}
          />
        ))}
      </Route>
    </Routes>
  );
}
